import { render, staticRenderFns } from "./AliCaptcha.vue?vue&type=template&id=6a1f91b1"
import script from "./AliCaptcha.vue?vue&type=script&lang=js"
export * from "./AliCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports